import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchDailyRoi = createAsyncThunk(
  "dailyRoi/fetchDailyRoi",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/daily-roi", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const dailyRoiSlice = createSlice({
  name: "dailyRoi",
  initialState: {
    dailyRois: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyRoi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchDailyRoi.fulfilled, (state, action) => {
        state.status = "success";
        state.dailyRois = action.payload.data;
      })
      .addCase(fetchDailyRoi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default dailyRoiSlice.reducer;
